export const BUILD_VERSION = '1793828759';
